
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat_spaces/new/group",
      function () {
        return require("private-next-pages/chat_spaces/new/group.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat_spaces/new/group"])
      });
    }
  